var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-help-link"}},[_c('link-widget',{on:{"linkClick":function($event){}}},[_vm._v(_vm._s(_vm.$t('login.login_help'))+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }